import { Grid } from "@mui/material";
import { HolidayListView } from "app/components/leave-plans/HolidayListView";
import { LeavePlansForClient } from "app/components/leave-plans/LeavePlansForClient";

export const LeavePlanClientView = () => {
    return (
        <div className="content-container" style={{width: "100%" }}>
            <Grid container spacing={6}>
                <LeavePlansForClient />
                <HolidayListView />
            </Grid>
        </div>
    );
}